/**
 * DevDash - Developer Dashboard
 *
 * A dev-gated control surface for debugging, QA, and experimentation.
 * Only available in non-production environments (local, dev, qa).
 *
 * Usage:
 *   - Cmd+Shift+D (Mac) / Ctrl+Shift+D (Windows/Linux) to toggle
 *   - Can be disabled per-user via localStorage: devdash.disabled=true
 *   - Can be disabled globally via env var: NEXT_PUBLIC_DEVDASH_DISABLED=true
 */

// biome-ignore lint/performance/noBarrelFile: DevDash public API barrel file
export { DevDashProvider } from './components/DevDashProvider';
export { useDevDash } from './hooks/useDevDash';
export type { DevDashContextValue, DevDashState } from './types';
export { isDevDashEnabled } from './utils/gating';
